
import ApplyNow from '~/pages/_lang/apply-now'
export default ApplyNow
